import { dynamicImportWithRetry } from "@fatso83/retry-dynamic-import"
import type { Component } from "vue"

export async function setupVueApp(rootComponent: Component, rootProps?: {[key: string]: any}) {
  const module = await dynamicImportWithRetry(() => import("./setup"))
  const _setupSync = module?.setupVueApp
  return _setupSync?.(rootComponent, rootProps)
}

export async function setupVueSSRApp(rootComponent: Component, rootProps?: {[key: string]: any}) {
  const module = await dynamicImportWithRetry(() => import("./setup"))
  const _setupSync = module?.setupVueSSRApp
  return _setupSync?.(rootComponent, rootProps)
}
